'use strict';

require('react');
require('classnames');
require('../Box/Box.js');
require('../../style-inject.es-dcee06b6.js');
require('../../Button-e2bdd95d.js');
require('./utils/getRootBtnClasses.js');
require('../Icon/Icon.js');
require('../../icons/LoaderOutline.js');
require('../Spinner/Spinner.js');
require('./components/buttonContent/index.js');
var components_Button_Button = require('./Button.js');



module.exports = components_Button_Button;
